<template>
    <div class="mt-0 mt-lg-0 h-100 d-flex flex-column overflow-hidden" v-if="kudos">
        <div class="col-12 h-100 d-flex flex-column p-0 m-0">
            <h3>{{ title ? title : 'Kudos!' }}</h3>

            <section class="w-100 mb-0 scroll-panel mt-3 mt-lg-3">
                <div v-if="kudos.length > 0">
                    <div v-if="kudo.comment" v-for="kudo in kudos" :for="kudo.id" class="kudos-message">
                        <div class="message" v-html="formatKudo(kudo.comment)"></div>
                        <div class="message" v-if="kudo.admin_response" v-html="formatKudo(kudo.admin_response)"></div>
                        <span class="timestamp">{{ kudo.ts }}</span>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div v-else class="col-12 card container text-left p-0 mb-4 no-surveys">
                    <div class="card-body text-center">
                        <h5 class="text-center w-100 p-0 m-0">You don't seem to have any Kudos at the moment</h5>
                    </div>
                </div>
            </section>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Kudos',
    props: [
        'user',
        'limit',
        'title'
    ],
    data() {
        return {
            kudos: [],
            icons: {
                'icon-thumbsup': 'kudos-icon-thumbsup',
                'icon-cheer': 'kudos-icon-cheer',
                'icon-smile': 'kudos-icon-smile',
                'icon-wow': 'kudos-icon-wow'
            }
        }
    },
    methods: {
        getCurrentKudos() {
            let self = this;
            let limit = (self.limit != '' && self.limit != undefined ? '?limit=' + self.limit : '')
            axios.get("/api/users/" + self.user.id + "/kudos" + limit).then(response => {
                if (response.data && response.data.length !== '') {
                    self.kudos = response.data;
                }
            });
        },
        formatKudo(text) {
            let message = text;

            message = message.replace('|', '') + ' ';
            if (message.indexOf('icon-') > -1) {
                let icon = message.match(/icon-(?:.*\s)?([^"]*) /)[0].trim();
                message = message.replace(icon, '<i class="kudos-icon kudos-' + icon + '"></i>');
            }

            return message;
        }
    },
    mounted() {
        let self = this;
        self.getCurrentKudos();
    },
    created() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Kudos.vue